import { useQueryClient } from "@tanstack/react-query";

export default function useInvalidateReturnRequests() {
	const queryClient = useQueryClient();

	return () => {
		queryClient.invalidateQueries({
			queryKey: ["ReturnRequestsServiceReturnRequestsControllerGetAll"],
		});
	};
}
